<template>
    <div>
        <div class="container mt-4">
            <div class="">
               
                <div class="row shadow-sm p-3 mb-5 bg-body rounded">
                    <!-- <h1>Artikulli {{ $route.params.id }} </h1> -->
                    <!-- Loading state -->
                    <div class="text-center position-relative">
                        <!-- <img 
                            src="../../assets//foto1.png" 
                            class="rounded"
                            @click="showPostInModal('../../assets/foto1.png')"/> -->
                        <!-- <img v-if="postStore.post.pDetailsFileUrl" :src="postStore.post.pDetailsFileUrl"
                                alt="Post image" class="img-fluid" /> -->
                     </div>
                     <div class="">
                        <div v-if="postStore.loading">Loading...</div>
                        <div v-if="postStore.error">{{ postStore.error }}</div>
    
                        <!-- Post content -->
                        <div v-if="!postStore.loading && !postStore.error && postStore.post">
                            <h3 class="text-center">{{ postStore.post.priceDetailsTitle || 'No Title' }}</h3>
                             <!-- <prokuroria-chips :item="postStore.post.webPage || 'No Webpage'" />
                            <p>{{ postStore.post.createdDate || 'No Date' }}</p>  -->
                            <div v-html="postStore.post.pDetailsContent || 'No Content'"></div>  
                            <div v-html="postStore?.post.htmlContent"></div>  
                            <iframe
                                v-if="isPdfFile"
                                :src="pdfFileUrl"
                                class="pdf-viewer"
                                title="PDF"
                            ></iframe>

                            <!-- <p>{{ postStore.post.categoryName || 'No Category' }}</p> -->
                        </div>
                        <div v-if="!postStore.loading && !postStore.error && !postStore.post">
                            Post not found
                        </div>
                     </div>
                </div>
            </div>
        </div>
        <div v-if="showModal" class="modal-overlay" @click="closeImageModal">
            <img :src="modalImageSrc" class="modal-image" />
        </div>
    </div>
</template>

<script>
import { usePostsStore } from '@/store/PostStore/postStore';
import Swal from 'sweetalert2';
//import ProkuroriaChips from './ProkuroriaChips.vue';

export default {
  components: {
    //ProkuroriaChips 
  },
    name: 'SingleArticle',
   data(){
    return{
        postStore: usePostsStore(),
        showModal: false,
        modalImageSrc: '../../assets//foto1.png',
    }
   },
    computed: {
        pdfFileUrl() {
            const fileUrl = this.postStore.post?.pDetailsFileUrl;

            if (!fileUrl) {
                return '';
            }

            if (/^https?:\/\//i.test(fileUrl)) {
                return fileUrl;
            }

            return `https://prokuroria-rks.org/uploads/${fileUrl}`;
        },
        isPdfFile() {
            return this.pdfFileUrl.toLowerCase().split('?')[0].endsWith('.pdf');
        },
    },
    methods: {
        async fetchPostById() {
            const postData = {
                webPage: 'Këshilli Prokurorial i Kosovës',
                
                count: 0,language: 'AL',
                categoryId: 7,
                postId: this.$route.params.id,
            };
            await this.postStore.getPostById(postData);
            },
            async showPostInModal() {
    const post = this.postStore.post;

    if (!post) {
      return Swal.fire('Gabim', 'Postimi nuk u gjet.', 'error');
    }

    await Swal.fire({
      html: `
        ${post.pDetailsFileUrl ? `<img src="/img/foto1.ab07f76c.png" />` : ''}
      `,
      showCloseButton: true,
      focusConfirm: false,
      showConfirmButton:false,
      width: '90%',
    });
  }
    },
    async created() {
        await this.fetchPostById(); // ✅ pret që të mbarojë ngarkimi i postit
    }
};
</script>

<style scoped>
img {
    max-width: 100%;
    height: auto;
    margin-bottom: 1rem;
}

h1 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

p {
    margin-bottom: 1rem;
    overflow-wrap: break-word !important;
}

p>strong>em{
    overflow-wrap: break-word !important;
}
.table-responsive td {
  border: 1px solid #dee2e6 !important;
  padding: 8px !important;
  vertical-align: middle !important;
}

.table-responsive tr:nth-child(even) {
  background-color: #f9f9f9 !important;
}

.fw-bold {
  font-weight: bold !important;
}

.pdf-viewer {
  width: 100%;
  height: 900px;
  border: 0;
  display: block;
}

@media (max-width: 991px) {
  .pdf-viewer {
    height: 75vh;
    min-height: 620px;
  }
}

@media (max-width: 575px) {
  .pdf-viewer {
    height: 70vh;
    min-height: 480px;
  }
}
</style>
